const numberFormats = {
  en: {
    currency: { style: "currency", currency: "USD" }
  },
  pr: {
    currency: { style: "currency", currency: "R$" }
  },
  ar: {
    currency: { style: "currency", currency: "USD", currencyDisplay: "code" }
  }
};
export default numberFormats;
